export default {
  header: 'Pages',
  icon: 'FileIcon',
  children: [
    {
      title: 'Home',
      route: 'home',
      icon: 'GridIcon',
    },
    {
      title: 'Second Page',
      route: 'second-page',
      icon: 'FileIcon',
    },
  ],
}
